/**
 * ページ全体の共通文言
 */
export const t = {
    /**
     * バリデーションエラーメッセージ
     */
    validation: {
        /** 入力形式 */
        format: (fieldName) => `${fieldName}の形式が正しくありません`,
        /** 半角数字 */
        halfWidthNumber: () => '半角数字で入力してください',
        /** 最大文字数制限 */
        maxLength: (length, fieldName) => `${fieldName}は${length}文字以内で入力してください`,
        /** 必須入力 */
        required: (fieldName) => `${fieldName}を入力してください`,
        /** 必須選択 */
        requiredSelect: (fieldName) => `${fieldName}を選択してください`,
        /** 期間選択 */
        requiredSelectPeriod: (fromFieldName, toFieldName) => `${toFieldName}は${fromFieldName}より後の日付を選択してください`,
    },
    /**
     * warningメッセージ
     */
    warning: {
        /**
         * 一般ユーザー以外に対する説明用文言
         * @description 仮登録・PROFFIT利用無効・フリーコンサル等
         */
        nonFormalRegistration: () => '大変申し訳ございません。現在、運営チームが審査をさせて頂いております。\n審査が完了しましたら詳細をご確認いただけますので、今しばらくお待ちいただけますようお願い申し上げます。\n登録申請後１週間たっても承認／不承認の回答がない場合はこちらへご連絡ください（support@proffit.jp）',
    },
};
